// extracted by mini-css-extract-plugin
export var btn = "section-header-module--btn--28c09";
export var description = "section-header-module--description--96c52";
export var greenBackground = "section-header-module--greenBackground--c8131";
export var noBottomMargin = "section-header-module--noBottomMargin--bed17";
export var root = "section-header-module--root--b2ad8";
export var subtitle = "section-header-module--subtitle--71671";
export var title = "section-header-module--title--07aa0";